import { Component } from "@angular/core";

@Component({
  selector: "app-footer-layout",
  standalone: true,
  templateUrl: "./FooterLayout.html",
  styleUrl: "./FooterLayout.scss",
})
export class FooterLayout {}
